import React, { MouseEvent, useContext, useMemo, useTransition } from 'react';
import { makeLink } from 'simple-utils';
import { Column, ColumnHeader, TableRow } from "../table/Table";
import { bigNumber, formatMoney } from "../utils/money-utils";
import { ProcedureReportEntry, ProcedureType, Summary, ProcedureLabel, procedures, props, propsLabel, HidebleProp } from "./procedure-models";
import { ProcedureContext } from './procedure-store';

type Getter = {
    (g:ProcedureReportEntry):number
    key?:string
}

function getter(type:ProcedureType, prop:keyof Summary){
    let result:Getter = (g:ProcedureReportEntry):number => g.info[type]?.[prop] ?? 0
    result.key = `${type}.${prop}`;
    return result; 
}

type NumberColumn = Column<ProcedureReportEntry> & ({getter: (r: ProcedureReportEntry) => number});

function getColumns(type: ProcedureType):NumberColumn[]{
    return props.map(p => {
        let g = getter(type, p);
        return {
            id: g.key,
            label: propsLabel[p],
            colGroup: p.match(/leads/) ? 'col-divider text-end' : 'text-end',
            render: p == 'spend' ? r => formatMoney(g(r)) : (r) => bigNumber(g(r)),
            getter: g
        }
    });
}

const numberColumns = procedures.flatMap(k => getColumns(k));


export const columns:Column<ProcedureReportEntry>[] = [
    {id: "name", label: "Conta", render: (r) => r.name},
    ...numberColumns
]


function ThSorter({col}:{col:NumberColumn}){
    const {state: {sorter}, dispatch} = useContext(ProcedureContext);
    return <div className='d-flex' onClick={() => dispatch({type: 'numberSorter', id: col.id, getter: col.getter})}>
            {col.label} {sorter?.id == col.id && <i className={`ms-2 fa ${sorter.asc ? 'fa-caret-up' : 'fa-caret-down'}`}></i> }
        </div>
}


export function ProcedureReportTable({data, columns, onClick}:{data:ProcedureReportEntry[], columns:Column<ProcedureReportEntry>[], onClick?:(i:ProcedureReportEntry, e:MouseEvent) => void}){
    const {state: {hiddenProps, filter}} = useContext(ProcedureContext);
    const visibleColumns = useMemo(() =>{
        return columns.filter(c => !hiddenProps?.includes(c.id.replace(/.+?\./, '') as HidebleProp))
    }, [columns, hiddenProps])

    const filteredData = useMemo(() =>{
        if(!filter) return data;
        let search = makeLink(filter);
        return data.filter(a => makeLink(a.name).includes(search))
    }, [data, filter])

    return <table className="table table-striped table-hover">
                <thead>
                    <tr>
                        <th rowSpan={2}>Conta</th> 
                        {procedures.map(p => 
                            <th key={p} colSpan={props.length - (hiddenProps?.length ?? 0)} className="fw-normal text-muted">
                                {ProcedureLabel[p]}
                            </th>)}
                    </tr>
                    <tr>
                        {numberColumns.map(c => 
                            hiddenProps?.includes(c.id.replace(/.+?\./, '') as HidebleProp) ? null :
                            <th key={c.id} className={c.id.match(/leads/) ? 'col-divider' : ''}>
                            <ThSorter col={c} />
                        </th>)}
                    </tr>
                </thead>
                <tbody>
                {
                    filteredData.map( (r, i) => <TableRow key={i} item={r} index={i} columns={visibleColumns} onClick={onClick} />) 
                }
                </tbody>
           </table>
        
}



